import { API } from 'app/utils/client';
import { ISpecialty } from 'app/models';
import { CRUDService } from './api';

export class SpecialtyService extends CRUDService<ISpecialty> { }

const instance = new SpecialtyService(API, 'v1/specialties');
export default instance;
